import React from "react";
import PropTypes from "prop-types";
import {Button, ButtonGroup} from "semantic-ui-react";
import ServiceDetailDataSourcesTable from "./ServiceDetailDataSourcesTable";
import Overview from "./Overview";
import Commercials from "./Commercials";
import Technicals from "./Technicals";

export default class ServiceDetailInfo extends React.Component {

    static propTypes = {
        resourceType: PropTypes.string,
        serviceDetail: PropTypes.object,
        associatedCountries: PropTypes.array,
        dpInputFields: PropTypes.array,
        requiredInputs: PropTypes.array,
        dpSources: PropTypes.array,
        subDPTypeOptions: PropTypes.array,
    }

    state = {
        showOverview: true,
        showCommercials: false,
        showTechnicals: false,
    }

    render() {

        const {serviceDetail, dpSources, associatedCountries, resourceType} = this.props;

        return(
            <div className="detail-container">
                <div>
                    <ButtonGroup>
                        <Button
                            content="Overview"
                            onClick={() => this.setState({
                                showOverview: true,
                                showCommercials: false,
                                showTechnicals: false,
                                showCountries: false,
                            })}
                        />
                        <Button
                            content="Commercials"
                            onClick={() => this.setState({
                                showOverview: false,
                                showCommercials: true,
                                showTechnicals: false,
                                showCountries: false,
                            })}
                        />
                        <Button
                            disabled={true}
                            content="Technicals"
                            onClick={() => this.setState({
                                showOverview: false,
                                showCommercials: false,
                                showTechnicals: true,
                                showCountries: false,
                            })}
                        />
                    </ButtonGroup>

                    {this.state.showOverview
                        ? (<Overview serviceDetail={serviceDetail} associatedCountries={associatedCountries}/>)
                        : null
                    }

                    {this.state.showCommercials
                        ? (<Commercials serviceDetail={serviceDetail}/>)
                        : null
                    }

                    {this.state.showTechnicals
                        ? (<Technicals serviceDetail={serviceDetail}/>)
                        : null
                    }

                </div>

                {dpSources.length > 0
                    ? (
                        <ServiceDetailDataSourcesTable
                            resourceType={resourceType}
                            dpSources={dpSources}
                        />
                    ) : (
                        <div className={"associated-sources-table"}>
                            <h2>No Associated Data Sources</h2>
                        </div>
                    )
                }
            </div>
        );
    }
}
